/**
 * 텍스트의 공백 포함 글자 수를 계산합니다.
 * @param {string} text - 글자 수를 계산할 텍스트
 * @param {Array} [flexibleData] - 선택: extraSettings/textLength의 data_value
 * @param {string} [fieldName] - 선택: field 값 (예: "subjectComment")
 * @returns {string|Object} - flexibleData 없으면 "123자", 있으면 {text: "123자", color: "red"|"green"|undefined}
 */
export function calculateTextNumber(text, flexibleData, fieldName) {
  if (!text) text = "";
  const length = text.length;

  // 파라미터 없으면 기존처럼 문자열만 반환 (하위 호환성)
  if (!flexibleData || !fieldName) {
    return length + "자";
  }

  // validation 설정 찾기
  const config = flexibleData.find(
    (item) => item.field === fieldName && item.isActive === true
  );

  // 설정 없거나 빈칸이면 일반 텍스트
  if (!config || text.trim() === "") {
    return { text: length + "자", color: undefined };
  }

  const min = parseInt(config.min);
  const max = parseInt(config.max);

  let color = undefined;
  if (length < min || length > max) {
    color = "red";
  } else {
    color = "green";
  }

  return { text: length + "자", color };
}

/**
 * NEIS 학생부 바이트 계산 규칙:
 *  - 한글(가-힣, 자모): 3바이트
 *  - ASCII(영문/숫자/반각 특수문자/탭/스페이스): 1바이트
 *  - 줄바꿈(\n): 2바이트 (\r은 \r\n 의 일부로 보고 0바이트 처리)
 *  - 그 외 비ASCII(전각 기호, 스마트따옴표, 그리스 문자, 한자 등): 3바이트
 *
 * 단일 패스 O(n) - 기존 다중 regex 방식 대비 큰 텍스트에서 수십 배 빠름.
 * for..of 로 순회하므로 이모지 같은 surrogate pair 도 한 글자로 안전하게 처리.
 */
export function calculateTextNumberByte(text = "") {
  if (!text) return "0bytes";

  let bytes = 0;

  for (const ch of text) {
    const code = ch.codePointAt(0);

    if (code === 0x0a) {
      bytes += 2; // \n
      continue;
    }
    if (code === 0x0d) {
      continue; // \r 은 \r\n 의 일부로 간주하여 카운트하지 않음
    }

    // 한글 음절 / 자모 / 호환 자모 / 자모 확장
    if (
      (code >= 0xac00 && code <= 0xd7a3) || // 가-힣
      (code >= 0x1100 && code <= 0x11ff) || // 한글 자모
      (code >= 0x3130 && code <= 0x318f) || // 호환용 한글 자모
      (code >= 0xa960 && code <= 0xa97f) || // 한글 자모 확장-A
      (code >= 0xd7b0 && code <= 0xd7ff) //    한글 자모 확장-B
    ) {
      bytes += 3;
      continue;
    }

    // ASCII (영문/숫자/반각 특수문자/탭/스페이스)
    if (code <= 0x7f) {
      bytes += 1;
      continue;
    }

    // 그 외 비ASCII (전각 기호, 스마트따옴표, 그리스 문자, 한자, 이모지 등)
    bytes += 3;
  }

  return bytes + "bytes";
}

export function getSchoolYearForSort(schoolYear) {
  if (!schoolYear) return { isNumeric: false, value: "" };

  // console.log("schoolYear", schoolYear);
  // 문자열로 변환
  const yearStr = schoolYear.toString();

  // 첫 번째 4자리 연속 숫자 찾기
  const match = yearStr.match(/\d{4}/);

  if (match) {
    // 숫자를 찾았으면 숫자로 반환
    const year = parseInt(match[0]);

    // console.log("year", year);

    return { isNumeric: true, value: year };
  } else {
    // 4자리 숫자를 못 찾으면 문자열로 반환
    // console.log("yearStr", yearStr);

    return { isNumeric: false, value: yearStr };
  }
}
